import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";
import { FiLink } from "react-icons/fi";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
  default: 3,
  1100: 3,
  700: 2,
  500: 1,
};

const tabList = ["All", "Websites", "Mobile Apps", "Graphic Design", "Other"];
const tabListContent = [
  {
    // All PROJECTS
    porftoliItems: [
      {
        img: "/img/portfolio/leadgiants-home-screenshot.PNG",
        width: 738,
        height: 451,
        title: "Lead Giants",
        subTitle: "Outsourcing Excellence",
        alterText: "www.LeadGiants.com",
        portfolioLink:
          "https://www.leadgiants.com/",
      },
      {
        img: "/img/portfolio/unisafebox-preview.PNG",
        width: 636,
        height: 559,
        title: "UniSafeBox",
        subTitle: "Password Manager",
        alterText: "unisafebox",
        portfolioLink:
          "https://apps.apple.com/us/app/unisafebox/id1572216162",
      },
      // {
      //   img: "/img/portfolio/m-portfolio-3.jpg",
      //   width: 400,
      //   height: 700,
      //   title: "Visual Design",
      //   subTitle: "Themeforest Marke",
      //   alterText: "Business Mockup",
      //   portfolioLink:
      //     "https://dribbble.com/shots/16529407-Deski-Saas-Software-React-Template",
      // },
      {
        img: "/img/portfolio/GameNight02082023.gif",
        width: 840,
        height: 473,
        title: "Game Night",
        subTitle: "BioFi Event",
        alterText: "game night",
        portfolioLink:
          "https://www.youtube.com/watch?v=2C3Umw6Lp2M",
      },
      {
        img: "/img/portfolio/krptic-wallet-home.PNG",
        width: 761,
        height: 561,
        title: "Krptic Wallet",
        subTitle: "Safely Manage Your Digital Assets",
        alterText: "krptic wallet",
        portfolioLink:
          "https://www.krptic.com/",
      },
      {
        img: "/img/portfolio/callcenterinc.png",
        width: 779,
        height: 596,
        title: "Call Center",
        subTitle: "Philippines",
        alterText: "call center",
        portfolioLink:
          "https://www.leadgiants.com/",
      },
      {
        img: "/img/portfolio/wellnessapp1.png",
        width: 717,
        height: 478,
        title: "Rest Azzure",
        subTitle: "Microsoft Hackathon",
        alterText: "rest azzure",
        portfolioLink: "https://devpost.com/software/rest-azzure",
      },
      {
        img: "/img/portfolio/biometric-financial-home.PNG",
        width: 738,
        height: 451,
        title: "Biometric Financial",
        subTitle: "BioFi Token & Ecosystem",
        alterText: "biometric financial",
        portfolioLink: "https://www.biometricfinancial.org/",
      },
      {
        img: "/img/portfolio/open-racing-home.PNG",
        width: 744,
        height: 458,
        title: "Open Racing",
        subTitle: "NFT Racing",
        alterText: "open racing",
        portfolioLink: "https://race.opendao.cloud/",
      },
      {
        img: "/img/portfolio/ethos-metaverse-home.PNG",
        width: 737,
        height: 446,
        title: "Ethos Metaverse",
        subTitle: "NFT Minting & VR",
        alterText: "ethos metaverse",
        portfolioLink: "https://ethosmetaverse.net/",
      },
    ],
  },
  {
    // WEBSITES
    porftoliItems: [
      {
        img: "/img/portfolio/leadgiants-home-screenshot.PNG",
        width: 738,
        height: 451,
        title: "Lead Giants",
        subTitle: "Outsourcing Excellence",
        alterText: "www.LeadGiants.com",
        portfolioLink:
          "https://www.leadgiants.com/",
      },
      {
        img: "/img/portfolio/biometric-financial-home.PNG",
        width: 738,
        height: 451,
        title: "Biometric Financial",
        subTitle: "BioFi Token & Ecosystem",
        alterText: "biometric financial",
        portfolioLink: "https://www.biometricfinancial.org/",
      },
      {
        img: "/img/portfolio/open-racing-home.PNG",
        width: 744,
        height: 458,
        title: "Open Racing",
        subTitle: "NFT Racing",
        alterText: "open racing",
        portfolioLink: "https://race.opendao.cloud/",
      },
      {
        img: "/img/portfolio/ethos-metaverse-home.PNG",
        width: 737,
        height: 446,
        title: "Ethos Metaverse",
        subTitle: "NFT Minting & VR",
        alterText: "ethos metaverse",
        portfolioLink: "https://ethosmetaverse.net/",
      },
    ],
  },
  {
    // MOBILE APPS
    porftoliItems: [
      {
        img: "/img/portfolio/unisafebox-preview.PNG",
        width: 636,
        height: 559,
        title: "UniSafeBox",
        subTitle: "Password Manager",
        alterText: "unisafebox",
        portfolioLink:
          "https://apps.apple.com/us/app/unisafebox/id1572216162",
      },
      {
        img: "/img/portfolio/krptic-wallet-home.PNG",
        width: 761,
        height: 561,
        title: "Krptic Wallet",
        subTitle: "Safely Manage Your Digital Assets",
        alterText: "krptic wallet",
        portfolioLink:
          "https://www.krptic.com/",
      },
    ],
  },
  {
    // GRAPHIC DESIGN
    porftoliItems: [
      {
        img: "/img/portfolio/GameNight02082023.gif",
        width: 840,
        height: 473,
        title: "Game Night",
        subTitle: "BioFi Event",
        alterText: "game night",
        portfolioLink:
          "https://www.youtube.com/watch?v=2C3Umw6Lp2M",
      },
    ],
  },
  {
    // OTHER
    porftoliItems: [
      {
        img: "/img/portfolio/callcenterinc.png",
        width: 779,
        height: 596,
        title: "Call Center",
        subTitle: "Philippines",
        alterText: "call center",
        portfolioLink:
          "https://www.leadgiants.com/",
      },
      {
        img: "/img/portfolio/wellnessapp1.png",
        width: 717,
        height: 478,
        title: "Rest Azzure",
        subTitle: "Microsoft Hackathon",
        alterText: "rest azzure",
        portfolioLink: "https://devpost.com/software/rest-azzure",
      },
    ],
  },
];

const Portfolio = () => {
  return (
    <div className="portfolio-filter-01">
      <Tabs>
        <TabList className="filter d-flex flex-wrap justify-content-start">
          {tabList.map((val, i) => (
            <Tab key={i}>{val}</Tab>
          ))}
        </TabList>
        {/* End tablist */}
        <Gallery>
          {tabListContent.map((tabContent, i) => (
            <TabPanel key={i}>
              <div className="portfolio-content ">
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  {tabContent.porftoliItems.map((val, i) => (
                    <div className="portfolio-box-01" key={i}>
                      <div className="portfolio-img">
                        <div className="portfolio-info">
                          <h5>
                            <a
                              href={val.portfolioLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {val.title}
                            </a>
                          </h5>
                          <span>{val.subTitle}</span>
                        </div>
                        {/* End .portfolio-info */}
                        <Item
                          original={val.img}
                          thumbnail={val.img}
                          width={val.width}
                          height={val.height}
                        >
                          {({ ref, open }) => (
                            <div className="gallery-link">
                              <img
                                src={val.img}
                                alt="Childhood"
                                role="button"
                                ref={ref}
                                onClick={open}
                              />
                            </div>
                          )}
                        </Item>

                        <a
                          className="portfolio-icon"
                          href={val.portfolioLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FiLink />
                        </a>
                        {/* End .portfolio-icon */}
                      </div>
                    </div>
                  ))}
                </Masonry>
              </div>
              {/* End list wrapper */}
            </TabPanel>
          ))}
        </Gallery>
        {/* End tabpanel */}
      </Tabs>
    </div>
  );
};

export default Portfolio;
